function o({
  date: t,
  format: r
}) {
  switch (r) {
    case "1:00 pm":
      return t.toFormat("h:mm a").toLowerCase();
    default:
      throw new Error(`Unsupported format: ${r}`);
  }
}
export {
  o as formatTime
};
